import React, { PropTypes } from 'react';

import './style.scss';

const NoEntries = ({ title, children }) => {
  return (
    <div className="NoEntries">
      <h4>{title}</h4>
      {children}
    </div>
  );
};

NoEntries.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ])
};

export default NoEntries;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/NoEntries/index.js
 **/